import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0fcea6eb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  key: 0,
  class: "handle-content"
};
const _hoisted_3 = {
  key: 1
};
import { getQueryList } from '@/api/payManage/accountManage';
import { OK, reportEvent } from '@/common';
import SvgIcon from '@/components/SvgIcon.vue';
import DetailModal from '@/views/payManage/accountManage/components/DetailModal.vue';
import AddOrEditModal from '@/views/payManage/accountManage/components/AddOrEditModal.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AccountTableBlock',
  props: {
    PayChannelList: null,
    EntityList: null
  },
  emits: ['changePageTableList', 'refresh'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const columns = [{
      title: '主体',
      dataIndex: 'mchName',
      key: 'mchName',
      width: 350
    }, {
      title: '支付渠道',
      dataIndex: 'payChannel',
      key: 'payChannel',
      width: 350
    }, {
      title: '创建时间',
      dataIndex: 'createDate',
      key: 'createDate'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const routeName = computed(() => useRoute().name);
    const dataSource = ref([]),
      pageIndex = ref(1),
      pageSize = ref(20),
      pageTotal = ref(0),
      tableRef = ref(),
      detailVisible = ref(false),
      detailItem = ref({}),
      editVisible = ref(false),
      editItem = ref({});
    const queryList = async (queryObj = {}) => {
        const startTime = new Date().getTime();
        const params = {
          pageNum: pageIndex.value,
          pageSize: pageSize.value,
          ...queryObj
        };
        try {
          const {
            code,
            count,
            data
          } = await getQueryList(params);
          if (code === OK) {
            pageTotal.value = count;
            dataSource.value = data;
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '主体管理搜索',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'succeed'
              }
            });
          } else {
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '主体管理搜索',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'failed'
              }
            });
          }
        } catch (e) {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '主体管理搜索',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      },
      refresh = () => {
        emit('refresh');
      },
      clearEditItem = () => {
        editItem.value = {};
      },
      changePage = async (page, pageS) => {
        pageIndex.value = page;
        pageSize.value = pageS;
        emit('changePageTableList');
      },
      openDetail = item => {
        detailItem.value = item;
        detailVisible.value = true;
      },
      handleEdit = item => {
        editItem.value = item;
        editVisible.value = true;
      };
    onMounted(async () => {
      await queryList();
    });
    expose({
      queryList,
      pageIndex
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        class: "add-btn",
        onClick: _cache[0] || (_cache[0] = $event => handleEdit({}))
      }, {
        icon: _withCtx(() => [_createVNode(SvgIcon, {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新建 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: _unref(routeName),
        btnType: 'add'
      }]]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "key",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "link",
          onClick: $event => handleEdit(record)
        }, {
          default: _withCtx(() => [_createTextVNode(" 修改 ")]),
          _: 2
        }, 1032, ["onClick"])), [[_directive_permission, {
          permissionValue: _unref(routeName),
          btnType: 'update'
        }]]), _createVNode(_component_a_button, {
          type: "link",
          onClick: $event => openDetail(record)
        }, {
          default: _withCtx(() => [_createTextVNode("查看详情")]),
          _: 2
        }, 1032, ["onClick"])])) : _createCommentVNode("", true), column.dataIndex === 'payChannel' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString((record === null || record === void 0 ? void 0 : record.payChannelName) === '抖音支付' ? '抖音/tiktok支付' : (record === null || record === void 0 ? void 0 : record.payChannelName) || '----'), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[1] || (_cache[1] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(DetailModal, {
        "modal-visible": detailVisible.value,
        "onUpdate:modal-visible": _cache[3] || (_cache[3] = $event => detailVisible.value = $event),
        "edit-item": detailItem.value
      }, null, 8, ["modal-visible", "edit-item"]), _createVNode(AddOrEditModal, {
        onRefresh: refresh,
        onClearEditItem: clearEditItem,
        "modal-visible": editVisible.value,
        "onUpdate:modal-visible": _cache[4] || (_cache[4] = $event => editVisible.value = $event),
        "edit-item": editItem.value,
        PayChannelList: props.PayChannelList,
        EntityList: props.EntityList
      }, null, 8, ["modal-visible", "edit-item", "PayChannelList", "EntityList"])]);
    };
  }
});